import React from "react";

const Parking = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M3.2002 19.9998V9.29959C3.2002 8.50921 3.66566 7.79297 4.38792 7.47196L11.3879 4.36085C11.905 4.13102 12.4953 4.13102 13.0125 4.36085L20.0125 7.47196C20.7347 7.79297 21.2002 8.50921 21.2002 9.29959V19.9998M7.2002 14.9998L8.64741 12.1054C8.98619 11.4278 9.67872 10.9998 10.4363 10.9998H13.9641C14.7217 10.9998 15.4142 11.4278 15.753 12.1054L17.2002 14.9998M7.2002 14.9998H17.2002M7.2002 14.9998V17.9998C7.2002 18.5521 7.64791 18.9998 8.2002 18.9998M17.2002 14.9998V17.9998C17.2002 18.5521 16.7525 18.9998 16.2002 18.9998M16.2002 19.9998V18.9998M16.2002 18.9998H8.2002M8.2002 18.9998V19.9998"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Parking;
